import { Component, inject, ViewChild } from '@angular/core';
import { NgForm, NonNullableFormBuilder, Validators } from '@angular/forms';
import { AssessmentFormService } from '../../services/assessment-form.service';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-delete-form-dialog',
  templateUrl: './delete-form-dialog.component.html',
  styleUrls: ['./delete-form-dialog.component.scss']
})
export class DeleteFormDialogComponent {


  isBusy = false;
  isDeleted = false;
  hasError = false;
  deletionSectionVisible = false;
  createdDate: string | null = null;

  formBuilder = inject(NonNullableFormBuilder);
  
  dialogForm = this.formBuilder.group({
    password: ['', [Validators.required]],
  });

  constructor(private assessmentFormService: AssessmentFormService,private dialogRef: MatDialogRef<DeleteFormDialogComponent>) { }

  getDaysRemaining(): number {
    if (!this.createdDate) {
      return 90;
    }

    const created = new Date(this.createdDate);
    
    // Check if date is valid
    if (isNaN(created.getTime())) {
      return 90;
    }

    // Add 90 days to the created date
    const expiryDate = new Date(created.getTime() + (90 * 24 * 60 * 60 * 1000));
    const now = new Date();
    
    // Calculate difference in days
    const timeDiff = expiryDate.getTime() - now.getTime();
    const daysDiff = Math.ceil(timeDiff / (1000 * 60 * 60 * 24));
    
    return Math.max(0, daysDiff);
  }

  deleteForm(): void {
    const form = this.assessmentFormService.getForm();

    if (form && this.dialogForm && this.dialogForm.valid) {
      this.hasError = false;
      this.isBusy = true;

      this.assessmentFormService.deleteForms(this.dialogForm.controls.password.value).subscribe({
        next: (result) => {
          this.isDeleted = true;
          this.isBusy = false;
          setTimeout(() => {
            this.close('deleted');
          }, 5000);
        },
        error: (error) => {
          this.hasError = true;
          this.isBusy = false;
        },
        complete: () => {
          this.isBusy = false;
        }
      });
    }
  }

  close(closeReason: string): void {
   this.dialogRef.close(closeReason);
  }

  showDeletionSection(): void {
    this.deletionSectionVisible = true;
  }

  onOverlayClick(event: Event): void {
    // Only close if not busy or deleted
    if (!this.isBusy && !this.isDeleted) {
      this.close('overlayClick');
    }
  }
}